
import React, {Component} from 'react';
import Iframe from '../../components/iframe/iframe';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  width: 100%;

height:100%;
  justify-content: flex-start;
  align-items:stretch;
  align-self:center;



`;

    class Agriculture extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src: 'https://resourcewatch.org/embed/data/explore/ed521429-58b4-4c55-9bbe-4f4bfd2fcb1f?section=Discover&zoom=3&lat=0&lng=0&pitch=0&bearing=0&basemap=dark&labels=light&layers=%255B%257B%2522dataset%2522%253A%2522ed521429-58b4-4c55-9bbe-4f4bfd2fcb1f%2522%252C%2522opacity%2522%253A1%252C%2522layer%2522%253A%2522de6266c0-adfa-4a46-8372-0a1466027ef3%2522%257D%255D&page=1&sort=most-viewed&sortDirection=-1'
        };
    }

    render() {
        return (
            <Center>
                <Iframe source={this.state.src} />
            </Center>
        );
    }
}

export default Agriculture;